// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"248":"29dc6ab7","478":"7dcca220","483":"4eda85d6","662":"1ef50b9b","718":"1b4a0ec1","719":"6278aa51","982":"2f505d5e"}[chunkId] + ".chunk.js";
};